
import { defineComponent } from 'vue'
import TeamMonthlyCalendar from '@/components/calendars/team-monthly.vue'
import TeamsDropdown from '@/components/teams-dropdown.vue'

export default defineComponent({
  components: { TeamsDropdown, TeamMonthlyCalendar }
})
